import { CSSProperties } from 'react';
import {
    business_1100
} from '@fiverr-private/sass/helpers';
import { AvatarProps, ColorType } from './types';
import { AVATAR_BACKGROUND_COLORS, ROUNDED_FULL } from './constants';

export const getAvatarBackgroundColor = ({ color, username }: { color: AvatarProps['color'], username: AvatarProps['username'] }) => {

    const getRandomColor = () => {
        const colors = Object.keys(AVATAR_BACKGROUND_COLORS);
        const colorIndex = Math.floor(Math.random() * colors.length);
        const ramdonColor = colors[colorIndex] as ColorType;
        return AVATAR_BACKGROUND_COLORS[ramdonColor];
    };
    if (username && color === 'auto'){
        return getRandomColor();
    }

    if (color) {
        return AVATAR_BACKGROUND_COLORS[color];
    }

    return AVATAR_BACKGROUND_COLORS.grey_700;
};

export const getRingStyle = ({ showRing, ringSize }: { showRing: AvatarProps['showRing'], ringSize: number }) => {
    const style: CSSProperties = {
        borderRadius: ROUNDED_FULL
    };

    if (showRing) {
        style.border = `${ringSize}px solid ${business_1100}`; // This is the actual ring
        style.padding = `${ringSize}px`; // push away from the avatar itself to create an illusion of a ring
    }

    return style;
};
